import { createContext, useContext } from "react";

export const VideoDataContext = createContext({
  videoId: null,
  videoData: null,
  originalVideo: null,
  videoApiDataFailed: false,
  videoApiUrl: null,
  domain: null,
  dispatchVideoApiEvent: () => {}
});

export const useVideoDataContext = () => useContext(VideoDataContext);
